import React, { StrictMode } from 'react';
import ReactDOM, { createRoot } from 'react-dom/client';
import App from './App.tsx';

if (process.env.NODE_ENV !== 'production') {
  const { default: axe } = await import('@axe-core/react');
  axe(React, ReactDOM, 1000);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
